import React, { Component } from "react";
import { connect } from "react-redux";
import { getVideoDetails, selectVideo } from "../../ducks/videos";
import ConnectedVideo from "../../components/connected-video";
import PlotContainer from "../../components/plot-container";
import TimeControls from "../../components/time-controls";
import TimePlotOverlay from "../../components/time-plot-overlay";
import TrackingMap from "../../components/tracking-map";
import DetailMap from "../../components/detail-map";
import Select from 'react-select';
import * as d3Scale from "d3-scale";
import { categoricalScale } from "../../modules/colors";

import DropdownStyle from "../../components/styles/dropdown.style.js";

import Styles from "./video.module.scss";


class Video extends Component {
    componentDidMount() {
        this.props.getVideoDetails(this.props.id);
    }

    componentWillUpdate(nextProps) {
        if (nextProps.video) { 
            const { processed } = nextProps.video;
            const timeExtents = processed.extents.time;

            if (!this.timeScale) {
                this.timeScale = d3Scale.scaleTime()
                    .domain(timeExtents)
                    .range([0, 100]);
            }

            if (!this.dataScale) {
                const numberMinutes = (timeExtents[1] - timeExtents[0]) / (processed.timeInterval * 1000);
                this.datumWidth = 100 / (numberMinutes);
                this.dataScale = d3Scale.scaleLinear()
                    .domain(processed.extents.data)
                    .range([0, 1]);
            }
        }
    }

    renderDetails() {
        const { video } = this.props;

        const clientOptions = [
            { label: video.details.Data.Client },
        ];
        const clientDropdown = (
            <div className={Styles.detailField}>
                <h4>Client</h4>
                <Select
                    options={clientOptions}
                    value={clientOptions[0]}
                    styles={DropdownStyle}
                    className={Styles.detailDropdownSelect}
                    isSearchable={false}
                />
            </div>
        );

        const timeOptions = [
            { label: video.details.Data.Date + " " + video.details.Data.Time },
        ];

        const timeDropdown = (
            <div className={Styles.detailField}>
                <h4>Time + Date</h4>
                <Select
                    options={timeOptions}
                    value={timeOptions[0]}
                    styles={DropdownStyle}
                    className={Styles.detailDropdownSelect}
                    isSearchable={false}
                />
            </div>
        );


        const locationOptions = [
            { label: video.details.Data.Location },
        ]
        const locationDropdown = (
            <div className={Styles.detailField}>
                <h5>Location</h5>
                <Select
                    options={locationOptions}
                    value={locationOptions[0]}
                    styles={DropdownStyle}
                    className={Styles.detailDropdownSelect}
                    isSearchable={false}
                />
            </div>
        );

        const directionOptions = [
            { label: video.details.Data.Camera },
        ]
        const directionDropdown = (
            <div className={Styles.detailField}>
                <h5>Camera Direction</h5>
                <Select
                    options={directionOptions}
                    value={directionOptions[0]}
                    styles={DropdownStyle}
                    className={Styles.detailDropdownSelect}
                    isSearchable={false}
                />
            </div>
        );


        return (
            <div className={Styles.detailsContainer}>
                <div className={Styles.detailFields}>
                    {clientDropdown}
                    {timeDropdown}
                    {locationDropdown}
                    {directionDropdown}
                </div>
                <div className={Styles.detailsVisualisations}>
                    <div className={Styles.detailVisMediaRow}>
                        <DetailMap video={video} />
                        <ConnectedVideo video={video} />                                
                    </div>
                    <div className={Styles.detailVisLabelRow}>
                        <label className={Styles.sectionLabel + " " + Styles.locationLabel}>Location</label>
                        <label className={Styles.sectionLabel}>Object Identification</label>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        const { video } = this.props;
        if (!video) return null;
        return (
            <div className={Styles.videoPage}>
                <div className={Styles.topRow}>
                    {this.renderDetails()}
                    <div className={Styles.mapVisualisationContainer}>
                        <TrackingMap video={video} />
                        <label className={Styles.sectionLabel}>Movement Tracking</label>
                    </div>
                </div>
                <div className={Styles.bottomRow}>
                    <PlotContainer
                        video={video}
                        timeScale={this.timeScale}
                        dataScale={this.dataScale}
                        datumWidth={this.datumWidth}
                        colors={categoricalScale}
                    />
                    <TimeControls video={video} timeScale={this.timeScale} />
                    <TimePlotOverlay timeScale={this.timeScale} video={video} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    const id = props.match.params.videoId;
    return {
        id,
        video: selectVideo(id, state),
    };
};
const mapDispatchToProps = {
    getVideoDetails,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Video);



// WEBPACK FOOTER //
// ./src/pages/video/video.js